import { render } from "./GenericTableHeader.vue?vue&type=template&id=8c083268&scoped=true"
import script from "./GenericTableHeader.vue?vue&type=script&lang=js"
export * from "./GenericTableHeader.vue?vue&type=script&lang=js"

import "./GenericTableHeader.vue?vue&type=style&index=0&id=8c083268&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c083268"]])

export default __exports__